import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store'

// Containers
const TheContainer = () => import('@/containers/TheContainer')
const TheOutside = () => import('@/containers/TheOutside')

// Pages
const Dashboard = () => import('@/pages/private/Dashboard')
const Notifications = () => import('@/pages/private/Notifications')
const Clientboard = () => import('@/pages/private/Clientboard')

const Profile = () => import('@/pages/private/Profile')
// const Settings = () => import('@/pages/private/Settings')

const Users = () => import('@/pages/private/Users')

const Log4Net = () => import('@/pages/private/Log4Net')
const Snapshot = () => import('@/pages/private/Apps/Reports/Components/Report1')
const TasksViewer = () => import('@/pages/private/TasksViewer')
const TasksScheduler = () => import('@/pages/private/TasksScheduler')
//const TasksScheduler2 = () => import('@/pages/private/TasksScheduler2')

const SetupUsers = () => import('@/pages/private/Apps/Setup/Setup_Users')
const SetupTasksAt = () => import('@/pages/private/Apps/Setup/Setup_TasksAt')
const SetupReports = () => import('@/pages/private/Apps/Setup/Setup_Reports')
const SetupSystemSettings = () => import('@/pages/private/Apps/Setup/Setup_SystemSettings')

const Documents = () => import('@/pages/private/Documents')
const PNRs = () => import('@/pages/private/Apps/Pnrs/PNRLibrary')
const Tickets = () => import('@/pages/private/Apps/Tickets/TicketsRepository')
const Queued = () => import('@/pages/private/Apps/Invoicing/Queue')
const Charters = () => import('@/pages/private/Apps/Charters/Charters')

const InventoryLines = () => import('@/pages/private/Apps/Charges/InventoryLines')

const BookingForms2 = () => import('@/pages/private/Apps/Accounts/BookingForms2')
const BookingForms = () => import('@/pages/private/Apps/Accounts/BookingForms')
const Bookings = () => import('@/pages/private/Apps/Bookings/Bookings')
const Invoices = () => import('@/pages/private/Apps/Accounts/SLTransactions2')
const Orders = () => import('@/pages/private/Apps/Orders/Orders')

const Invoicing = () => import('@/pages/private/Apps/Invoicing')

const Setup = () => import('@/pages/private/Apps/Setup/Setup')


const Bankings = () => import('@/pages/private/Apps/Accounts/Bankings')
const BankingsEdit = () => import('@/pages/private/Apps/Accounts/Components/BankingsEdit')
const BankingsRules = () => import('@/pages/private/Apps/Accounts/Components/BankingsRules')
const BankingsRefund = () => import('@/pages/private/Apps/Accounts/Components/BankingsRefund')

// Apps
const App_Accounts = () => import('@/pages/private/Apps/Accounts')
const App_Reportso = () => import('@/pages/private/Apps/AllReportso')
const App_Reports = () => import('@/pages/private/Apps/AllReports')
const App_Systems = () => import('@/pages/private/Apps/Systems')
const App_CarbonEmissions = () => import('@/pages/private/Apps/CarbonEmissions')
const App_OurEmissions = () => import('@/pages/private/Apps/OurEmissions')

// Logout
const Logout = () => import('@/pages/private/Logout')

const Signin = () => import('@/pages/public/Signin')
const Reset = () => import('@/pages/public/Reset')
const LockAccount = () => import('@/pages/public/LockAccount')
const Scheduler = () => import('@/pages/public/Scheduler')
const Published = () => import('@/pages/public/Published')

const CMSEdit = () => import('@/pages/private/Apps/Systems/Components/CMSEdit')

Vue.use(Router)

export const router = new Router({
    mode: 'history',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/',
            redirect: '/dashboard',
            name: 'Home',
            component: TheContainer,
            children: [
                {
                    path: 'dashboard',
                    name: 'Dashboard',
                    component: Dashboard
                },
                {
                    path: 'clientboard',
                    name: 'Clientboard',
                    component: Clientboard,
                },
                {
                    path: '/notifications',
                    name: 'Notifications',
                    component: Notifications
                },
                {
                    path: '/profile',
                    name: 'Profile',
                    component: Profile,
                },
                // {
                //     path: '/settings',
                //     name: 'Settings',
                //     component: Settings,
                // },
                {
                    path: '/setup_systemsettings',
                    name: 'Setup System',
                    component: SetupSystemSettings,
                },
                {
                    path: '/users',
                    name: 'Users',
                    component: Users,
                },
                {
                    path: '/setup_users',
                    name: 'Setup Users',
                    component: SetupUsers,
                },
                {
                    path: '/tasksviewer',
                    name: 'Tasks Viewer',
                    component: TasksViewer,
                },
                {
                    path: '/taskscheduler',
                    name: 'Task Scheduler',
                    component: TasksScheduler,
                },
                // {
                //     path: '/taskscheduler2',
                //     name: 'Task Scheduler2',
                //     component: TasksScheduler2,
                // },
                {
                    path: '/setup_tasksat',
                    name: 'Tasks',
                    component: SetupTasksAt,
                },
                {
                    path: '/setup_reports',
                    name: 'Setup Reports',
                    component: SetupReports,
                },
                // {
                //     path: '/audit',
                //     name: 'Audit',
                //     component: Audit,
                // },
                {
                    path: '/log4net',
                    name: 'Log4Net',
                    component: Log4Net,
                },
                {
                    path: '/snapshot',
                    name: 'Snapshot',
                    component: Snapshot,
                },
                {
                    path: '/setup',
                    name: 'Setup',
                    component: Setup,
                },
                {
                    path: '/bookingforms2',
                    name: 'Bookingforms2',
                    component: BookingForms2,
                },
                {
                    path: '/bookingforms',
                    name: 'Bookingforms',
                    component: BookingForms,
                },
                {
                    path: '/invoices',
                    name: 'Invoices',
                    component: Invoices,
                },
                {
                    path: '/bookings',
                    name: 'Bookings',
                    component: Bookings,
                },
                {
                    path: '/bankings',
                    name: 'Bankings',
                    component: Bankings,
                },
                {
                    path: '/bankingsedit',
                    name: 'BankingsEdit',
                    component: BankingsEdit,
                },
                {
                    path: '/bankingsrules',
                    name: 'BankingsRules',
                    component: BankingsRules,
                },
{
                    path: '/bankingsrefund',
                    name: 'BankingsRefund',
                    component: BankingsRefund,
                },
                {
                    path: '/documents',
                    name: 'Documents',
                    component: Documents,
                },
                {
                    path: '/pnrs',
                    name: 'PNRs',
                    component: PNRs,
                },
                {
                    path: '/charters',
                    name: 'Charters',
                    component: Charters,
                },
                {
                    path: '/tickets',
                    name: 'Tickets',
                    component: Tickets,
                },
                {
                    path: '/orders',
                    name: 'Orders',
                    component: Orders,
                },
                {
                    path: '/queued',
                    name: 'Queued',
                    component: Queued,
                },
                {
                    path: '/invoicing',
                    name: 'Invoicing',
                    component: Invoicing,
                },
                {
                    path: '/inventorylines',
                    name: 'InventoryLines',
                    component: InventoryLines,
                },
                {
                    path: '/apps/Accounts',
                    name: 'Accounts',
                    component: App_Accounts,
                },
                {
                    path: '/apps/Reports',
                    name: 'Reports',
                    component: App_Reports,
                },
                 {
                    path: '/apps/Reportso',
                    name: 'Reports',
                    component: App_Reportso,
                },
                {
                    path: '/apps/Systems',
                    name: 'Systems',
                    component: App_Systems,
                },
                {
                    path: '/apps/CarbonEmissions',
                    name: 'CarbonEmissons',
                    component: App_CarbonEmissions,
                },
                {
                    path: '/apps/OurEmissions',
                    name: 'OurEmissions',
                    component: App_OurEmissions,
                },
                {
                    path: '/cmsedit',
                    name: 'CMSEdit',
                    component: CMSEdit
                },
                {
                    path: '/logout',
                    name: 'Logout',
                    component: Logout
                },
            ]
        },
        {
            path: '/',
            component: TheOutside,
            name: "Public",
            children: [
                {
                    path: "/signin",
                    name: "Signin",
                    component: Signin
                },
                {
                    path: "/reset",
                    name: "Reset",
                    component: Reset
                },
                {
                    path: '/lock-account',
                    name: 'LockAccount',
                    component: LockAccount,
                },
                {
                    path: '/scheduler',
                    name: 'Scheduler',
                    component: Scheduler,
                },
                {
                    path: "/published",
                    name: "Published",
                    component: Published
                },

            ]
        },

    ]
})

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/signin', '/reset', '/scheduler', '/published'];
    const authRequired = !publicPages.includes(to.path);

    console.log(to)
    if (authRequired) {
        if (!store.getters.user) {
            return next('/signin');
        } else {
            next();
        }
    } else {
        next();
    }

    // store.dispatch('audit', { type: 0, name: "route: " + to.fullPath, route: to.fullPath, category: "navigate", data: "User navigation to page" })
    store.dispatch('clearerror')
})
